module.exports = __webpack_public_path__ + "img/instagram.05d5d59a.png";